import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';
import toastr from 'toastr';

/* Actions */
import * as dimensionAdminActions from '../../actions/dimensionAdmin/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityHeader from '../../components/common/entity/entityHeader';
import EntityTable from '../../components/common/entity/entityTable';
import FormPopup from '../../components/dimensionAdmin/formPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import ImportDimensionInstancesFormPopup from '../../components/dimensionAdmin/importDimensionInstancesFormPopup';
import EntityUseQuery from '../entityUseQuery';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  importDimensionInstancesFormPopup: "importDimensionInstancesFormPopup",
  entityUseQuery: "entityUseQuery",
  closeFormConfirmPopup: "closeFormConfirmPopup",
}

class DimensionAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: {
        searchText: '',
        showDisabledEntities: false,
        selectedTags: [],
      },
      searchTimeoutObject: null,
      tableDescriptor: TableDescriptors.dimensionList,
      entityApiKey: "dimension",
      initialNewEntity: { 
        domain_input_source: Constants.selectKeys.dimension.domain_input_source.DEF_USER,
        allow_empty_dimension_instance_value: false,
        dimension_instances: [],
        tags: [],
      },      
      entityUseQueryId: "",
      formHasChanges: false,
    };
  }
 
  componentDidMount() {
    EntityTableTooling.fetchList(this);
    this.props.actions.getTagsList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    EntityTableTooling.feedbackMessages(this, prevProps, 
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "dimensionAdmin.entityNameSingularWithArticle"})),
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "dimensionAdmin.entityNamePlural"})),
      intl.formatMessage({id: "dimensionAdmin.genderVocal"}),
      (this.props.delete.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.delete.errors.message : ""),
      (this.props.save.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.save.errors.message : ""),
      true,
    );
    
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.dimensionInstancesList.status],
      [this.props.dimensionInstancesList.status],
      null,
      intl.formatMessage({ id: "dimensionAdmin.errors.dimension_instances_loading" }),
      [() => {
        let dimension_instances = this.props.dimensionInstancesList.data.collection ? this.props.dimensionInstancesList.data.collection : []
        this.props.actions.setSaveEntityDataByKey(this.state.entityApiKey + ".dimension_instances",dimension_instances);   
      }]    
    );
    
    //handle download dimension instances imoprt feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.downloadImportDimensionInstances.status],
      [this.props.downloadImportDimensionInstances.status],
      intl.formatMessage({ id: "common.entity.downloadImportFileSuccess" }),
      intl.formatMessage({ id: "common.entity.downloadImportFileFailure" })
    );

    //handle imoprt dimension instances feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.importDimensionInstances.status],
      [this.props.importDimensionInstances.status],
      intl.formatMessage(
        { id: "common.entity.uploadImportSuccess" },
        {entityNameSingular: intl.formatMessage({ id: "dimensionAdmin.dimensionInstancesNamePlural" }) }),
      null,
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.importDimensionInstancesFormPopup])) {
          InterfaceTooling.popupHide(popupIds.importDimensionInstancesFormPopup, this.setState.bind(this));
        }
        this.props.actions.getDimensionInstances({
          order_fields: ["value"],
          order_directions: [Constants.crudGenerator.orderTypes.ASC],
          fields_are: ["dimension_id"],
          searches_are: [this.props.save.data.dimension ? this.props.save.data.dimension.id : null],          
          per_page: Constants.interface.fullListPageSize
        });     
      }]  
    );
  }

  getListQueryParams(defaultQueryParams) {
    let newQueryParams = defaultQueryParams;
    let tags_filter = [];
    if(this.state.topControlsFormData.selectedTags.length > 0) {
      tags_filter = this.state.topControlsFormData.selectedTags;
    }
    newQueryParams.tags_filter = tags_filter;
    return newQueryParams;
  }
  
  handleShowFormPopup = async (event) => {
    EntityTableTooling.handleShowFormPopup(this, event);
    if(!InterfaceTooling.popupHasToRender(EntityTableTooling.getFormPopupState(this))) { 
      if(event.currentTarget.dataset.entitydata) {
        var entityObject = JSON.parse(event.currentTarget.dataset.entitydata)
        this.props.actions.getDimensionInstances({
          order_fields: ["value"],
          order_directions: [Constants.crudGenerator.orderTypes.ASC],
          fields_are: ["dimension_id"],
          searches_are: [entityObject.id],
          per_page: Constants.interface.fullListPageSize
        });
      }
    }
  };
  
  handleOnChangeForm = (event) => {    
    if(event.currentTarget.dataset.freetextlist) {
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let id = event.currentTarget.dataset.id;
      let listValue = event.currentTarget.dataset.value;
      let isDelete = event.currentTarget.dataset.delete;
      
      let dimension_instances = JavascriptUtilsTooling.deepCopy(
        JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
      );
            
      if(isDelete) {
        dimension_instances[index].isDeleted = true;
        if(dimension_instances[index].isNew) {           
          delete dimension_instances[index];
          dimension_instances = dimension_instances.filter(item => item);
        }
      }
      else if(id) {
        dimension_instances[index].value = listValue;
        dimension_instances[index].isModified = true;
      } else {
        dimension_instances.push({id: "new" + Date.now(), value: listValue, isNew: true });
      }
      this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path,dimension_instances);
      this.setState({
        formHasChanges: true
      })
    }
    else if(event.currentTarget.dataset.tagslist){
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let objectValue = event.currentTarget.dataset.value
      let isDelete = event.currentTarget.dataset.delete;
      let objectDefinition = [];
      
      if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)) {
        objectDefinition = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
        );
      }
      
      if(isDelete) { 
        delete objectDefinition[index];
        objectDefinition = objectDefinition.filter(item => item);
      } else {
        if(objectDefinition.includes(objectValue)) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.error(intl.formatMessage({id: "common.errors.duplicatedTag"}));
        }
        else if(objectDefinition.map(item => item.toLowerCase()).includes(objectValue.toLowerCase())) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.error(intl.formatMessage({id: "common.errors.duplicatedNonCapitalizedTag"}));
        } 
        else{
          objectDefinition.push(objectValue);
        }
      }
      this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path,objectDefinition);
      this.setState({ formHasChanges: true });
    }
    else {
      EntityTableTooling.handleOnChangeForm(this, event);
    }    
  };

  handleOnSaveForm = async () => {
    let finalData = JavascriptUtilsTooling.deepCopy(this.props.save.data);
    
    finalData.dimension.dimension_instances = 
      finalData.dimension.dimension_instances.filter(item => (item.isDeleted || item.isModified || item.isNew)).map(item => {
      if(item.isDeleted) {
        return {id: item.id, value: item.value, delete: true};
      }
      return item.isNew ? {value: item.value} : {id: item.id, value: item.value};
    });
    
    await this.props.actions.saveEntity(finalData);
  };

  handleShowImportDimensionInstancesFormPopup = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.importDimensionInstancesFormPopup, this.state, 
      this.setState.bind(this), this.props.importDimensionInstances.loading, () => {
        this.props.actions.resetImportDimensionInstances();      
      }    
    );
  };

  handleDownloadImportDimensionInstancesSheet = async () => {
    await this.props.actions.downloadImportFileDimensionInstances({
      dimension_id: this.props.save.data.dimension ? this.props.save.data.dimension.id : null
    });
  };

  handleOnSaveImportDimensionInstancesForm = async (event) => {
    let files = [];
    files = document.getElementById('import_file').files;
    files = Object.keys(files).map(key => files[key]);
    document.getElementById('import_file').value = '';
    await this.props.actions.importDimensionInstances(files, {
      dimension_id: this.props.save.data.dimension ? this.props.save.data.dimension.id : null
    });
  };

  handleEntityQueryDataPopup = event => { 
    InterfaceTooling.handleShowPopup(
      event, popupIds.entityUseQuery, this.state, 
      this.setState.bind(this), this.props.loadingEntityUseQueryData, () => {
        this.setState({
          entityUseQueryId: JSON.parse(event.currentTarget.dataset.entityid)
        });
      }
    );
  };

  render() {
    var loadingView = (this.props.list.firstLoading || this.props.tagsList.firstLoading);
    var errorLoadingView = (this.props.list.status !== null && this.props.list.status !== 200);
    
    let tagsArray = (this.props.tagsList && this.props.tagsList.status == 200) ? this.props.tagsList.data : [];
    return (
      <section className="dashboard_content_inner_view entity_admin_container dimension_admin_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
              <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleFormPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleRefresh={EntityTableTooling.fetchList.bind(null, this)}
              />
              <EntityTable
                entityTableDescriptor={this.state.tableDescriptor}
                data={this.props.list.data}
                loading={this.props.list.loading}
                page={this.props.list.page}
                totalPages={this.props.list.totalPages}
                totalRecords={this.props.list.totalRecords}
                orderBy={this.props.list.orderBy}
                orderByDirection={this.props.list.orderByDirection}
                topControlsFormData={this.state.topControlsFormData}
                handleOnChangeTopControls={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                fetchOrderList={EntityTableTooling.fetchListOrder.bind(null, this)}
                fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                handleShowFormPopup={this.handleShowFormPopup}
                handleDelete={EntityTableTooling.handleDeletePopup.bind(null, this)}
                handleActive={EntityTableTooling.handleActivePopup.bind(null, this)}
                enableTagsSearch={true}
                tagsOptions={tagsArray}
              />
              <FormPopup
                handleShowPopup={EntityTableTooling.handleShowFormPopupWithConfirmOnExit.bind(null, this)}
                handleOnChangeForm={this.handleOnChangeForm}
                handleButton={this.handleOnSaveForm}
                loadingButton={this.props.save.loading}
                fullLoading={this.props.save.loading || this.props.dimensionInstancesList.loading}
                statusButton={this.props.save.status}
                dimensionInstancesStatus={this.props.dimensionInstancesList.status}
                formData={this.props.save.data}
                errors={this.props.save.errors}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                popupState={EntityTableTooling.getFormPopupState(this)}
                handleShowImportDimensionInstancesFormPopup={this.handleShowImportDimensionInstancesFormPopup}
                handleEntityQueryDataPopup={this.handleEntityQueryDataPopup}
                tagsOptions={tagsArray}
              />
              <EntityUseQuery
                popupState={this.state[popupIds.entityUseQuery]}
                entityDefaultType={Constants.selectKeys.entityUseQuery.entityTypes.DIMENSION}
                entityDefaultId={this.state.entityUseQueryId}
                handleEntityQueryDataPopup={this.handleEntityQueryDataPopup}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirmTitle"}
                 values={{entityNameSingular: (<FormattedMessage id={"dimensionAdmin.entityNameSingular"}/>)}}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirm"}
                 values={{entityNameSingular: (<FormattedMessage id={"dimensionAdmin.entityNameSingularWithArticle"}/>)}}
                />)}
                handleConfirm={EntityTableTooling.handleDeleteConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleDeletePopup.bind(null, this)}
                popupState={EntityTableTooling.getDeletePopupState(this)}
                loading={this.props.delete.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirmTitle"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"dimensionAdmin.entityNameSingular"}/>),
                    activeAction: this.props.save.data.dimension && this.props.save.data.dimension.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirm"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"dimensionAdmin.entityNameSingularWithArticle"}/>),
                    activeAction: this.props.save.data.dimension && this.props.save.data.dimension.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                handleConfirm={EntityTableTooling.handleActiveConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleActivePopup.bind(null, this)}
                popupState={EntityTableTooling.getActivePopupState(this)}
                loading={this.props.save.loading}
              />
              <ImportDimensionInstancesFormPopup
                handleShowPopup={this.handleShowImportDimensionInstancesFormPopup}
                handleDownloadImportSheet={this.handleDownloadImportDimensionInstancesSheet}
                handleButton={this.handleOnSaveImportDimensionInstancesForm}
                loadingButton={this.props.importDimensionInstances.loading}
                fullLoading={this.props.importDimensionInstances.loading || this.props.downloadImportDimensionInstances.loading}
                statusButton={this.props.importDimensionInstances.status}
                errors={this.props.importDimensionInstances.errors}
                entityNamePlural={<FormattedMessage id={"dimensionAdmin.dimensionInstancesNamePlural"}/>}
                genderVocal={<FormattedMessage id={"dimensionAdmin.dimensionInstancesGenderVocal"}/>}
                popupState={this.state[popupIds.importDimensionInstancesFormPopup]}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"common.confirmExitPopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"common.confirmExitPopupDetail"}/>)}
                handleConfirm={InterfaceTooling.handleCloseForm.bind(null, this)}
                handleCancel={InterfaceTooling.handleCloseFormConfirmPopup.bind(null, this)}
                popupState={InterfaceTooling.getCloseFormConfirmPopupState(this)}
                loading={false}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.dimensionAdmin.list,
  save: state.reducer.dimensionAdmin.save,
  delete: state.reducer.dimensionAdmin.delete,
  dimensionInstancesList: state.reducer.dimensionAdmin.dimensionInstancesList,
  importDimensionInstances: state.reducer.dimensionAdmin.importDimensionInstances,
  downloadImportDimensionInstances: state.reducer.dimensionAdmin.downloadImportDimensionInstances,
  loadingEntityUseQueryData: state.reducer.entityUseQuery.queryData.loading,
  tagsList: state.reducer.dimensionAdmin.tagsList,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(dimensionAdminActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

DimensionAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DimensionAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/dimensionAdmin/index.jsx